import React from 'react';
import { ButtonComponent, StyledButtonText } from './styles';

type ButtonProps = {
  id: string;
  buttonText: string;
  onClick: () => void;
  disabled: boolean;
  state: string;
  iconPosition?: 'left' | 'right' | undefined;
  icon?: object | null;
  className?: string,
  style?: object,
}

export default function Button({ id = '', buttonText, onClick, disabled, state, icon, iconPosition, className, style }: ButtonProps) {
  const buttonId = id || `button-${buttonText.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <ButtonComponent
      id={buttonId}
      onClick={onClick}
      disabled={disabled}
      state={state}
      icon={icon}
      iconPosition={iconPosition}
      className={className}
      style={style}
    >
      <StyledButtonText>
        {buttonText}
      </StyledButtonText>
    </ButtonComponent>
  );
}

Button.defaultProps = {
  iconPosition: undefined,
  icon: undefined,
};

export { ButtonComponent, ToggleButton } from './styles';
export * from './sharedStyles';
